import React, { FC } from 'react';
import styles from './LabelWithDescription.module.scss';
import { LabelWithDescriptionProps } from './LabelWithDescription.props';

const LabelWithDescription: FC<LabelWithDescriptionProps> = ({ labelText, description }) => (
  <span className={styles.labelWithDescriptionWrapper}>
    <span className={styles.title}>{labelText}</span>
    <span className={styles.description}>{description}</span>
  </span>
);

export { LabelWithDescription };
